import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

type UtmParams = Partial<Record<typeof UTM_KEYS[number], string>>;

export const useUtmParams = (): UtmParams | undefined => {
  const { search } = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const params: UtmParams = {};

    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) {
        params[key] = value;
      }
    });

    return Object.keys(params).length > 0 ? params : undefined;
  }, [search]);
};
